import { RecordType } from 'shared/components/internal/Records';

import { hasValue } from '../../..';
import { RecordPropertyForDisplay } from '../RecordProperty';

export const useMappingFields = (metadata: RecordType, showEmpty: boolean) => {
  const fields: RecordPropertyForDisplay[] = [
    {
      name: 'metadata_vendor',
      label: 'Vendor',
      value: metadata.metadata_vendor,
    },
    {
      name: 'metadata_product',
      label: 'Product',
      value: metadata.metadata_product,
    },
    {
      name: 'metadata_mapperName',
      label: 'Mapping Name',
      value: metadata.metadata_mapperName,
    },
    {
      name: 'metadata_deviceEventId',
      label: 'Device Event ID',
      value: metadata.metadata_deviceEventId,
    },
  ];

  if (showEmpty) {
    return fields;
  }

  return fields.filter(({ value }) => hasValue(value));
};
